/*

:: cookies.js ::

A complete cookies reader/writer framework with full unicode support.

Revision #1 - September 4, 2014

https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
https://developer.mozilla.org/User:fusionchess

This framework is released under the GNU Public License, version 3 or later.
https://www.gnu.org/licenses/gpl-3.0-standalone.html

Syntaxes:

* docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
* docCookies.getItem(name)
* docCookies.removeItem(name[, path[, domain]])
* docCookies.hasItem(name)
* docCookies.keys()

*/

const docCookies = {
    getItem(sKey: string) {
        if (!sKey) {
            return null;
        }
        const value = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1'));
        return !value || value === 'null' ? null : value;
    },

    setItem(sKey: string, sValue: string, vEnd?: number | string | Date, sPath?: string, sDomain?: string, bSecure?: boolean) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        let sExpires = '';
        if (vEnd) {
            switch (typeof vEnd) {
                case 'number':
                    sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                    break;
                case 'string':
                    sExpires = '; expires=' + vEnd;
                    break;
                default:
                    if (vEnd?.toUTCString) {
                        sExpires = '; expires=' + vEnd.toUTCString();
                    }
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
        return true;
    },
    removeItem(sKey: string, sPath?: string, sDomain?: string) {
        if (!this.hasItem(sKey)) {
            return false;
        }
        document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
        return true;
    },
    hasItem(sKey: string) {
        if (!sKey) {
            return false;
        }
        return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
    },
    keys() {
        const aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
        for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    },
};

export default docCookies;
